import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function assignAgentFirmUser({
  data,
}: {
  data: {
    userId: string;
    serviceRequestId?: string;
  };
}) {
  const res = await fetcher(
    `${API_BASE_PATH}/assign`,
    {
      method: 'POST',
      body: data,
    },
    undefined
  );

  return res;
}
